import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createVoicePolicy } from 'API/VoicePolicies/createVoicePolicy';

const useCreateVoicePolicy = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (voicePolicyData) => {
        const response = await createVoicePolicy(voicePolicyData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['VoicePolicies'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateVoicePolicy;
